<template>
  <div class="">
    <span class="text-center txtStyle">نما جلو</span>
    <!--مچ پا چپ 34-->
    <svg class="vector" width="12" height="9" viewBox="0 0 12 9" @click="partClick(34)" :fill="fill34"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.70914 8.20169C1.70914 8.20169 6.2591 7.67456 8.31213 7.92426C10.3652 8.17395 11.4472 8.45139 11.2252 5.84348C11.0033 3.23558 11.7801 0.433451 5.70422 0.932836C-0.371636 1.43222 0.932319 3.51302 0.627138 5.28861C0.321958 7.0642 -1.00974 8.45139 1.70914 8.20169Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ پا چپ 35-->
    <svg class="vector2" width="12" height="9" viewBox="0 0 12 9" @click="partClick(35)" :fill="fill35"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2604 8.20169C10.2604 8.20169 5.71048 7.67456 3.65745 7.92426C1.60442 8.17395 0.522414 8.45139 0.744363 5.84348C0.966312 3.23558 0.18948 0.433451 6.26534 0.932836C12.3412 1.43222 11.0372 3.51302 11.3424 5.28861C11.6476 7.0642 12.9793 8.45139 10.2604 8.20169Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ران چپ  28-->
    <svg class="vector3" width="31" height="71" viewBox="0 0 31 71" @click="partClick(28)" :fill="fill28"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.35748 70.1629C8.71815 70.6068 10.9099 68.3318 12.8242 65.6129C14.5443 63.1992 18.151 62.6721 21.8964 64.9471C23.3668 65.8349 23.5055 67.7214 26.4741 69.3028C26.4741 69.3028 27.3064 32.598 29.5259 24.691C30.5802 15.6744 31.5512 11.1799 30.6079 8.07259C29.6646 4.9653 30.5524 4.88207 26.1412 3.57812C21.7299 2.27417 19.6492 1.33089 15.6263 0.554069C10.3828 0.33212 8.08005 0.748264 6.3322 1.35862C4.58434 1.96899 1.44931 3.38391 1.44931 3.38391C1.44931 3.38391 0.36731 2.96776 0.395054 6.68541C0.422797 10.4031 0.0898668 29.2687 2.08741 37.2589C2.72551 41.3372 3.69655 47.8015 3.80752 51.7134C3.9185 55.6252 8.35748 70.1629 8.35748 70.1629Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ران راست 29-->
    <svg class="vector4" width="31" height="71" viewBox="0 0 31 71" @click="partClick(29)" :fill="fill29"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.7461 70.1629C22.3855 70.6068 20.1937 68.3318 18.2794 65.6129C16.5593 63.1992 12.9526 62.6721 9.20722 64.9471C7.73681 65.8349 7.59809 67.7214 4.62952 69.3028C4.62952 69.3028 3.79721 32.598 1.57772 24.691C0.523457 15.6744 -0.447578 11.1799 0.495706 8.07259C1.43899 4.9653 0.551187 4.88207 4.96243 3.57812C9.37367 2.27417 11.4544 1.33089 15.4773 0.554069C20.7208 0.33212 23.0236 0.748264 24.7714 1.35862C26.5193 1.96899 29.6543 3.38391 29.6543 3.38391C29.6543 3.38391 30.7363 2.96776 30.7086 6.68541C30.6808 10.4031 31.0137 29.2687 29.0162 37.2589C28.3781 41.3372 27.407 47.8015 27.2961 51.7134C27.1851 55.6252 22.7461 70.1629 22.7461 70.1629Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--زانو راست 31-->
    <svg class="vector5" width="21" height="37" viewBox="0 0 21 37" @click="partClick(31)" :fill="fill31"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.37856 6.21478L3.12888 6.46444C2.62949 6.93608 0.576456 9.07236 0.659687 13.3449C0.715174 18.2278 0.65969 23.5823 1.96364 25.8018C3.26759 28.0213 6.04197 32.3493 8.45566 34.2359C10.8694 36.1224 9.87059 37.0102 12.2843 34.9295C14.0599 33.4313 16.1684 31.6002 17.1672 30.7124C17.4432 30.4683 17.7512 30.2629 18.0827 30.1021C18.5543 29.8246 19.4421 28.8258 19.886 25.2469C20.4964 20.475 21.4952 15.065 20.6629 11.5138C20.576 11.1878 20.5294 10.8524 20.5242 10.515C20.4838 9.14201 19.9635 7.82653 19.0537 6.79739C18.7741 6.50475 18.5318 6.17859 18.3324 5.82636C17.6943 4.66113 15.9464 1.85902 13.4773 0.527328C10.5919 -1.10955 4.37733 5.16052 3.37856 6.21478Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--زانو چپ 30-->
    <svg class="vector6" width="22" height="37" viewBox="0 0 22 37" @click="partClick(30)" :fill="fill30"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3107 6.21478L18.5604 6.46444C19.0598 6.93608 21.1128 9.07236 21.0296 13.3449C20.9741 18.2278 21.0296 23.5823 19.7256 25.8018C18.4217 28.0213 15.6473 32.3493 13.2336 34.2359C10.8199 36.1224 11.8187 37.0102 9.40498 34.9295C7.62939 33.4313 5.52087 31.6002 4.5221 30.7124C4.24608 30.4683 3.93806 30.2629 3.60656 30.1021C3.13492 29.8246 2.24712 28.8258 1.80322 25.2469C1.19286 20.475 0.194092 15.065 1.0264 11.5138C1.11331 11.1878 1.15989 10.8524 1.16512 10.515C1.20544 9.14201 1.72574 7.82653 2.63553 6.79739C2.91516 6.50475 3.15745 6.17859 3.35687 5.82636C3.99497 4.66113 5.74282 1.85902 8.21201 0.527328C11.1251 -1.10955 17.3397 5.16052 18.3107 6.21478Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف پا راست37-->
    <svg class="vector7" width="19" height="30" viewBox="0 0 19 30" @click="partClick(37)" :fill="fill37"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.01792 27.9985C5.01792 27.9985 7.32064 32.1878 13.6185 27.9985C15.5328 26.4726 19.2782 23.3931 18.1129 20.2026C16.9477 17.0121 12.8139 4.24999 11.9816 3.1125C11.1493 1.97501 9.59562 -0.660648 4.49078 1.33689L2.35452 1.9195C2.35452 1.9195 -0.197889 1.66981 1.13381 5.11002C2.4655 8.55024 5.29535 15.4584 5.04566 19.0096C4.82371 22.6163 4.74048 26.2784 5.01792 27.9985Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف پا چپ 36-->
    <svg class="vector8" width="19" height="30" viewBox="0 0 19 30" @click="partClick(36)" :fill="fill36"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.202 27.9985C14.202 27.9985 11.8993 32.1878 5.60147 27.9985C3.68716 26.4726 -0.0582298 23.3931 1.107 20.2026C2.27224 17.0121 6.40604 4.24999 7.23835 3.1125C8.07066 1.97501 9.6243 -0.660648 14.7291 1.33689L16.8654 1.9195C16.8654 1.9195 19.4178 1.66981 18.0861 5.11002C16.7544 8.55024 13.9246 15.4584 14.1743 19.0096C14.3962 22.6163 14.4794 26.2784 14.202 27.9985Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--لگن راست 27-->
    <svg class="vector9" width="30" height="38" viewBox="0 0 30 38" @click="partClick(27)" :fill="fill27"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.854492 37.3864C0.854492 37.3864 17.5284 32.9474 29.0698 34.723C29.0698 34.723 27.6549 16.7173 27.3774 14.9417C27.1 13.1661 25.9902 7.89485 25.6573 5.03725C25.3244 2.17965 25.6018 -0.483737 23.4101 0.736983C21.2183 1.9577 21.4958 2.2074 21.0241 4.45464C20.5525 6.70188 21.2884 13.4054 16.8217 15.8746C12.355 18.3438 9.67697 18.4097 9.17759 20.6292C8.57219 23.2582 7.50103 25.7575 6.01481 28.009C4.26696 30.7279 0.854492 37.3864 0.854492 37.3864Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--لگن چپ 26-->
    <svg class="vector10" width="30" height="38" viewBox="0 0 30 38" @click="partClick(26)" :fill="fill26"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.0561 37.3864C29.0561 37.3864 12.3822 32.9474 0.84082 34.723C0.84082 34.723 2.25575 16.7173 2.53318 14.9417C2.81062 13.1661 3.92037 7.89485 4.2533 5.03725C4.58622 2.17965 4.30878 -0.483737 6.50053 0.736983C8.69228 1.9577 8.41484 2.2074 8.88648 4.45464C9.35812 6.70188 9.19166 12.639 13.6584 15.1082C18.1251 17.5774 20.2336 18.4097 20.733 20.6292C21.3384 23.2582 22.4096 25.7575 23.8958 28.009C25.6437 30.7279 29.0561 37.3864 29.0561 37.3864Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مثانه 25-->
    <svg class="vector11" width="17" height="17" viewBox="0 0 17 17" @click="partClick(25)" :fill="fill25"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.950195 0.0465698C0.950195 0.0465698 2.58707 4.12488 3.3639 5.40109C4.44104 7.31495 5.32399 9.33179 5.99954 11.4215C6.66539 13.53 7.33124 18.2464 9.55073 15.583C11.4928 11.9209 15.7376 3.6255 16.0427 2.76544C16.3479 1.90539 17.5132 -0.0644082 13.851 0.129797C10.1888 0.324003 9.96688 0.434978 6.85959 0.268516C3.7523 0.102054 0.950195 0.0465698 0.950195 0.0465698Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سینه راست 20-->
    <svg class="_32" width="26" height="73" viewBox="0 0 26 73" @click="partClick(20)" :fill="fill20"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.07162 31.0802C1.07162 31.0802 -0.537517 37.3225 1.07162 40.9569C2.68075 44.5913 7.48041 56.1049 7.48041 56.1049C7.48041 56.1049 8.83985 58.2967 9.56118 59.4897C10.2825 60.6826 13.1401 66.7308 13.1401 66.7308L15.748 71.142C15.748 71.142 18.023 75.1926 21.4077 71.142C22.8781 63.679 26.0409 47.3934 25.9577 41.6782C25.8744 35.963 23.4607 26.2528 23.4607 24.4494C23.4607 22.6461 23.4885 17.2916 21.6019 13.3242C19.7154 9.35689 20.7696 8.05293 19.105 4.16882C17.4404 0.284709 13.0846 -0.048216 7.00876 1.92158C0.932904 3.89138 1.93167 8.52458 1.95942 10.1337C1.98716 11.6874 2.29234 28.8884 1.07162 31.0802Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سینه چپ 19-->
    <svg class="vector12" width="26" height="73" viewBox="0 0 26 73" @click="partClick(19)" :fill="fill19"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.2529 31.0802C25.2529 31.0802 26.862 37.3225 25.2529 40.9569C23.6438 44.5913 18.8441 56.1049 18.8441 56.1049C18.8441 56.1049 17.4847 58.2967 16.7633 59.4897C16.042 60.6826 13.1844 66.7308 13.1844 66.7308L10.5765 71.142C10.5765 71.142 8.30154 75.1926 4.91681 71.142C3.4464 63.679 0.283615 47.3934 0.366846 41.6782C0.450076 35.963 2.86377 26.2528 2.86377 24.4494C2.86377 22.6461 2.83603 17.2916 4.7226 13.3242C6.60917 9.35689 5.55491 8.05293 7.21953 4.16882C8.88415 0.284709 13.2399 -0.048216 19.3158 1.92158C25.3916 3.89138 24.3929 8.52458 24.3651 10.1337C24.3374 11.6874 24.0322 28.8884 25.2529 31.0802Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--شکم چپ21-->
    <svg class="vector13" width="27" height="47" viewBox="0 0 27 47" @click="partClick(21)" :fill="fill21"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.1925 0.676928C26.1903 0.614958 26.1675 0.555492 26.1276 0.508026C26.0877 0.46056 26.033 0.427827 25.9723 0.415053C25.9117 0.402279 25.8485 0.410206 25.7928 0.437558C25.7372 0.464909 25.6923 0.510112 25.6653 0.565955C24.3336 3.4513 20.7547 11.0531 18.3965 15.5198C15.4557 21.0963 10.6283 30.7788 6.63318 32.8596C4.02527 34.219 2.33291 32.9705 1.44511 31.9163C1.40869 31.8622 1.35435 31.8226 1.29164 31.8045C1.22894 31.7865 1.16189 31.7911 1.10226 31.8176C1.04264 31.8441 0.994254 31.8908 0.965626 31.9494C0.936998 32.0081 0.929958 32.0749 0.945729 32.1382C1.44512 35.1623 2.5826 42.6808 2.19419 45.7049C2.1903 45.7436 2.19459 45.7827 2.20678 45.8196C2.21897 45.8565 2.23879 45.8905 2.26495 45.9192C2.29111 45.948 2.32303 45.971 2.35863 45.9866C2.39424 46.0023 2.43274 46.0103 2.47163 46.0101H25.7763C25.8134 46.0125 25.8505 46.007 25.8853 45.9939C25.9201 45.9809 25.9517 45.9605 25.9779 45.9342C26.0042 45.908 26.0245 45.8764 26.0376 45.8416C26.0507 45.8068 26.0562 45.7697 26.0537 45.7326L26.1925 0.676928Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--22 شکم راست-->
    <svg class="vector14" width="27" height="47" viewBox="0 0 27 47" @click="partClick(22)" :fill="fill22"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.993164 0.676928C0.995312 0.614958 1.01816 0.555492 1.05805 0.508026C1.09795 0.46056 1.1526 0.427827 1.21328 0.415053C1.27396 0.402279 1.33716 0.410206 1.39281 0.437558C1.44846 0.464909 1.49335 0.510112 1.5203 0.565955C2.852 3.4513 6.43093 11.0531 8.78914 15.5198C11.73 21.0963 16.5574 30.7788 20.5524 32.8596C23.1603 34.219 24.8527 32.9705 25.7405 31.9163C25.7769 31.8622 25.8313 31.8226 25.894 31.8045C25.9567 31.7865 26.0237 31.7911 26.0834 31.8176C26.143 31.8441 26.1914 31.8908 26.22 31.9494C26.2486 32.0081 26.2557 32.0749 26.2399 32.1382C25.7405 35.1623 24.603 42.6808 24.9914 45.7049C24.9953 45.7436 24.991 45.7827 24.9788 45.8196C24.9666 45.8565 24.9468 45.8905 24.9207 45.9192C24.8945 45.948 24.8626 45.971 24.827 45.9866C24.7914 46.0023 24.7529 46.0103 24.714 46.0101H1.43707C1.4 46.0125 1.36283 46.007 1.32806 45.9939C1.29328 45.9809 1.26172 45.9605 1.23545 45.9342C1.20918 45.908 1.18881 45.8764 1.17574 45.8416C1.16266 45.8068 1.15718 45.7697 1.15964 45.7326L0.993164 0.676928Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--پایین شکم 23-->
    <svg class="vector15" width="25" height="32" viewBox="0 0 25 32" @click="partClick(23)" :fill="fill23"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.138672 0.590179V6.66605C0.138672 6.66605 0.277387 10.6611 1.60908 11.9096C2.94078 13.1581 3.82858 14.7672 5.18802 17.6248C6.54746 20.4824 7.13007 21.5921 6.96361 24.6439C6.79715 27.6957 5.6874 28.5835 9.40505 29.9985C12.6233 31.2192 21.4458 31.1637 23.7208 31.1082C23.8679 31.1082 24.0091 31.0498 24.1131 30.9457C24.2172 30.8416 24.2756 30.7005 24.2756 30.5533L24.1369 1.14505C24.1369 0.997891 24.0785 0.856765 23.9744 0.752706C23.8703 0.648647 23.7292 0.590179 23.5821 0.590179H0.138672Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--پایین شکم 24-->
    <svg class="vector16" width="25" height="32" viewBox="0 0 25 32" @click="partClick(24)" :fill="fill24"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.9924 0.590179V6.66605C24.9924 6.66605 24.8537 10.6611 23.522 11.9096C22.1903 13.1581 21.3025 14.7672 19.9431 17.6248C18.5837 20.4824 18.0011 21.5921 18.1675 24.6439C18.334 27.6957 19.4437 28.5835 15.7261 29.9985C12.5078 31.2192 3.68532 31.1637 1.41034 31.1082C1.26318 31.1082 1.12205 31.0498 1.018 30.9457C0.913936 30.8416 0.855469 30.7005 0.855469 30.5533L0.994187 1.14505C0.994187 0.997891 1.05265 0.856765 1.15671 0.752706C1.26077 0.648647 1.4019 0.590179 1.54906 0.590179H24.9924Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--گردن 2-->
    <svg class="vector17" width="22" height="22" viewBox="0 0 22 22" @click="partClick(2)" :fill="fill2"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.756836 0.650879C0.756836 0.650879 1.75561 15.9099 8.13665 20.4876C8.41409 21.0702 11.8543 22.7071 13.0195 21.0702C14.1848 19.4333 21.5368 12.0258 21.4259 1.03929C21.4259 1.03929 13.7409 3.64719 11.5214 3.64719C9.30189 3.64719 1.78335 2.03806 0.756836 0.650879Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سر شانه راست 4-->
    <svg class="vector18" width="19" height="17" viewBox="0 0 19 17" @click="partClick(4)" :fill="fill4"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.45232 0.223572C2.68703 5.23397 0.933671 10.7391 0.291992 16.4259C0.291992 16.4259 13.2483 12.5695 17.1047 15.4826L18.4641 8.07502C18.4363 8.04728 9.30869 3.91348 5.45232 0.223572Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سرشانه چپ 3-->
    <svg class="vector19" width="19" height="17" viewBox="0 0 19 17" @click="partClick(3)" :fill="fill3"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2608 0.223572C16.0261 5.23397 17.7794 10.7391 18.4211 16.4259C18.4211 16.4259 5.46483 12.5695 1.60846 15.4826L0.249023 8.07502C0.276767 8.04728 9.40443 3.91348 13.2608 0.223572Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--شانه راست 6-->
    <svg class="vector20" width="23" height="41" viewBox="0 0 23 41" @click="partClick(6)" :fill="fill6"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.45961 0.2388L0.435547 10.0601C0.435547 10.0601 7.8431 31.3394 6.98304 40.2451L19.9393 39.0522C19.9393 39.0522 21.5485 40.1064 22.6305 36.2223C22.6305 31.7556 22.686 22.9608 22.686 22.9608C22.686 22.9608 23.4905 14.4158 14.3074 7.00825L3.45961 0.2388Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--شانه چپ5-->
    <svg class="vector21" width="23" height="41" viewBox="0 0 23 41" @click="partClick(5)" :fill="fill5"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4191 0.129242L22.4431 9.95049C22.4431 9.95049 15.0355 31.2299 15.8956 40.1356L2.93931 38.9426C2.93931 38.9426 1.33018 39.9969 0.248181 36.1128C0.248181 31.646 0.192691 22.8513 0.192691 22.8513C0.192691 22.8513 -0.611872 14.3062 8.57128 6.89869L19.4191 0.129242Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--بازو راست 8-->
    <svg class="vector22" width="18" height="29" viewBox="0 0 18 29" @click="partClick(8)" :fill="fill8"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.17345 28.5412L14.8005 24.6571C14.8005 24.6571 17.0755 24.5184 17.3529 20.7175C17.6303 16.9166 18.5736 9.25938 16.7148 5.04235C14.856 0.825312 15.1057 0.658852 10.1118 0.631108H5.11796C5.11796 0.631108 -0.0701137 -0.922537 0.984145 4.93138C2.0384 10.7853 3.70304 18.8587 3.70304 18.8587L5.17345 28.5412Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--بازو چپ 7-->
    <svg class="vector23" width="18" height="29" viewBox="0 0 18 29" @click="partClick(7)" :fill="fill7"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8744 28.5412L3.24739 24.6571C3.24739 24.6571 0.97241 24.5184 0.694974 20.7175C0.417537 16.9166 -0.52575 9.25938 1.33307 5.04235C3.1919 0.825312 2.94221 0.658852 7.93607 0.631108C12.9299 0.603364 12.9299 0.631108 12.9299 0.631108C12.9299 0.631108 18.118 -0.922537 17.0637 4.93138C16.0095 10.7853 14.3449 18.8587 14.3449 18.8587L12.8744 28.5412Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--آرنج راست 10-->
    <svg class="vector24" width="18" height="19" viewBox="0 0 18 19" @click="partClick(10)" :fill="fill10"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.780644 5.84169C0.780644 5.84169 -0.245879 3.67767 1.77941 2.95634C3.8047 2.235 9.65861 0.209728 9.65861 0.209728C9.65861 0.209728 11.0735 -0.594842 11.6284 1.54142C12.1833 3.67768 16.5113 8.97671 16.761 10.4471C17.0107 11.9175 18.1759 13.6654 15.3461 14.47C12.5162 15.2745 5.94096 17.9657 5.94096 17.9657C5.94096 17.9657 2.66721 19.3528 2.38977 16.7172C2.11234 14.0816 1.55747 8.28313 0.780644 5.84169Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--آرنج چپ 9-->
    <svg class="vector25" width="17" height="19" viewBox="0 0 17 19" @click="partClick(9)" :fill="fill9"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7382 5.84169C16.7382 5.84169 17.7648 3.67767 15.7395 2.95634C13.7142 2.235 7.86028 0.209728 7.86028 0.209728C7.86028 0.209728 6.44535 -0.594842 5.89048 1.54142C5.3356 3.67768 1.00759 8.97671 0.7579 10.4471C0.508208 11.9175 -0.657024 13.6654 2.17283 14.47C5.00268 15.2745 11.5779 17.9657 11.5779 17.9657C11.5779 17.9657 14.8517 19.3528 15.1291 16.7172C15.4065 14.0816 15.9614 8.28313 16.7382 5.84169Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساعد راست 12-->
    <svg class="vector26" width="21" height="32" viewBox="0 0 21 32" @click="partClick(12)" :fill="fill12"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.16627 8.846C1.16627 8.846 -0.331889 5.84968 2.96961 5.82194C6.2711 5.7942 11.2927 2.18753 11.2927 2.18753C11.2927 2.18753 14.0116 -0.864269 15.2046 2.71466C16.3975 6.29359 19.5326 18.6673 20.4759 27.351C20.4759 27.351 8.24091 31.6235 5.99367 30.9577C5.99367 30.9577 3.44126 22.7456 3.05285 21.4139C2.66444 20.0822 1.97085 14.478 1.80439 12.7301C1.63792 10.9823 1.16627 8.846 1.16627 8.846Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساعد چپ 11-->
    <svg class="vector27" width="21" height="32" viewBox="0 0 21 32" @click="partClick(11)" :fill="fill11"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9649 8.846C19.9649 8.846 21.463 5.84968 18.1615 5.82194C14.86 5.7942 9.83843 2.18753 9.83843 2.18753C9.83843 2.18753 7.11955 -0.864269 5.92657 2.71466C4.73359 6.29359 1.59856 18.6673 0.655273 27.351C0.655273 27.351 12.8902 31.6235 15.1375 30.9577C15.1375 30.9577 17.6899 22.7456 18.0783 21.4139C18.4667 20.0822 19.1603 14.478 19.3268 12.7301C19.4932 10.9823 19.9649 8.846 19.9649 8.846Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ راست14-->
    <svg class="vector28" width="16" height="17" viewBox="0 0 16 17" @click="partClick(14)" :fill="fill14"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.882812 3.56565C0.882812 3.56565 11.0925 3.78761 14.8934 0.458374C14.8934 0.458374 15.7812 6.03485 15.6702 8.36532C15.5592 10.6958 16.5857 13.9695 13.09 13.6089C13.09 13.6089 7.95743 14.4967 6.26507 15.9948C6.26507 15.9948 5.2663 17.2988 4.73917 15.218C4.21204 13.1372 2.24225 5.09155 0.882812 3.56565Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--مچ چپ 13-->
    <svg class="vector29" width="16" height="17" viewBox="0 0 16 17" @click="partClick(13)" :fill="fill13"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5826 3.56565C15.5826 3.56565 5.37293 3.78761 1.57205 0.458374C1.57205 0.458374 0.684257 6.03485 0.795232 8.36532C0.906206 10.6958 -0.120312 13.9695 3.37539 13.6089C3.37539 13.6089 8.50797 14.4967 10.2003 15.9948C10.2003 15.9948 11.1991 17.2988 11.7262 15.218C12.2534 13.1372 14.1954 5.09155 15.5826 3.56565Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان دست راست 18-->
    <svg class="vector30" width="21" height="28" viewBox="0 0 21 28" @click="partClick(18)" :fill="fill18"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.66262 22.0025C5.85683 22.7793 5.66261 23.6116 4.80256 23.7781C4.02573 23.9446 3.60958 23.3897 3.41537 22.6129L0.410517 8.77733C0.363327 8.56005 0.58765 8.38121 0.794554 8.46263C8.01523 11.3042 12.7396 5.1053 14.4306 1.15316C14.5188 0.94717 14.8047 0.922059 14.9238 1.11185L20.7552 10.4057C20.8572 10.5696 20.9259 10.7521 20.9574 10.9426C20.9889 11.1331 20.9826 11.3279 20.9388 11.516C20.895 11.7041 20.8146 11.8817 20.7022 12.0386C20.5897 12.1956 20.4475 12.3289 20.2835 12.431C20.1196 12.533 19.9371 12.6017 19.7466 12.6332C19.5561 12.6647 19.3613 12.6584 19.1732 12.6146C18.9851 12.5708 18.8075 12.4904 18.6505 12.3779C18.4936 12.2655 18.3602 12.1233 18.2582 11.9593L15.151 7.02094C15.0391 6.82046 14.8539 6.67109 14.6343 6.60421C14.4147 6.53733 14.1777 6.55812 13.9731 6.66223C13.7685 6.76633 13.6121 6.94564 13.5369 7.16254C13.4617 7.37944 13.4734 7.61705 13.5696 7.8255L19.3402 22.7516C19.4617 23.108 19.4407 23.4976 19.2816 23.8389C19.1225 24.1802 18.8376 24.4468 18.4865 24.5829C18.1354 24.719 17.7453 24.7142 17.3977 24.5694C17.0501 24.4246 16.7719 24.151 16.6214 23.8059C16.6214 23.8059 12.654 13.3465 12.6263 13.3187C12.5747 13.2229 12.4892 13.1499 12.3865 13.1139C12.2839 13.078 12.1714 13.0818 12.0714 13.1245C11.9505 13.1657 11.8506 13.2528 11.7935 13.3671C11.7364 13.4813 11.7266 13.6135 11.7662 13.7349L15.7336 25.7202C15.7955 25.9023 15.821 26.0949 15.8085 26.2869C15.796 26.4789 15.7458 26.6666 15.6608 26.8392C15.5758 27.0118 15.4576 27.166 15.313 27.2929C15.1684 27.4198 15.0002 27.517 14.818 27.579C14.6359 27.6409 14.4433 27.6664 14.2513 27.6539C14.0593 27.6414 13.8716 27.5912 13.699 27.5062C13.5264 27.4212 13.3722 27.303 13.2453 27.1584C13.1184 27.0138 13.0211 26.8456 12.9592 26.6634L8.90863 14.4562C8.87184 14.3459 8.79271 14.2546 8.68865 14.2026C8.58459 14.1506 8.46413 14.142 8.35376 14.1788C8.24339 14.2156 8.15214 14.2947 8.10011 14.3988C8.04808 14.5028 8.03953 14.6233 8.07632 14.7337L11.2946 25.5814C11.3474 25.7654 11.3635 25.958 11.3419 26.1482C11.3203 26.3384 11.2614 26.5225 11.1687 26.69C11.0759 26.8574 10.9511 27.005 10.8013 27.1242C10.6516 27.2434 10.4798 27.3319 10.2958 27.3848C10.1118 27.4376 9.91922 27.4537 9.72902 27.4321C9.53882 27.4105 9.35474 27.3516 9.18729 27.2589C9.01983 27.1661 8.87228 27.0413 8.75307 26.8915C8.63385 26.7418 8.54531 26.57 8.49248 26.386L5.2742 15.455C5.23373 15.3189 5.14086 15.2044 5.01599 15.1368C4.89112 15.0691 4.74449 15.0539 4.60837 15.0943C4.47224 15.1348 4.35776 15.2277 4.29012 15.3526C4.22248 15.4774 4.20721 15.6241 4.24768 15.7602L5.66262 22.0025Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان دت چپ 17-->
    <svg class="vector31" width="22" height="28" viewBox="0 0 22 28" @click="partClick(17)" :fill="fill17"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1792 22.0025C15.985 22.7793 16.1792 23.6116 17.0392 23.7781C17.8161 23.9446 18.2322 23.3897 18.4264 22.6129L21.4313 8.77733C21.4785 8.56005 21.2541 8.38121 21.0472 8.46263C13.8266 11.3042 9.10224 5.1053 7.41115 1.15316C7.32301 0.94717 7.03711 0.922059 6.91802 1.11185L1.08664 10.4057C0.984625 10.5696 0.915894 10.7521 0.884386 10.9426C0.852879 11.1331 0.8592 11.3279 0.902994 11.516C0.946791 11.7041 1.02721 11.8817 1.13964 12.0386C1.25207 12.1956 1.39431 12.3289 1.55827 12.431C1.72222 12.533 1.90466 12.6017 2.09517 12.6332C2.28568 12.6647 2.48054 12.6584 2.6686 12.6146C2.85667 12.5708 3.03426 12.4904 3.19125 12.3779C3.34824 12.2655 3.48155 12.1233 3.58357 11.9593L6.69084 7.02094C6.8027 6.82046 6.98788 6.67109 7.2075 6.60421C7.42711 6.53733 7.6641 6.55812 7.86871 6.66223C8.07333 6.76633 8.22966 6.94564 8.3049 7.16254C8.38014 7.37944 8.36843 7.61705 8.27223 7.8255L2.50156 22.7516C2.3801 23.108 2.40112 23.4976 2.56023 23.8389C2.71934 24.1802 3.0042 24.4468 3.35529 24.5829C3.70637 24.719 4.09649 24.7142 4.44409 24.5694C4.79168 24.4246 5.06985 24.151 5.22043 23.8059C5.22043 23.8059 9.18778 13.3465 9.21552 13.3187C9.26705 13.2229 9.35256 13.1499 9.45525 13.1139C9.55794 13.078 9.67036 13.0818 9.7704 13.1245C9.89133 13.1657 9.99118 13.2528 10.0483 13.3671C10.1054 13.4813 10.1152 13.6135 10.0756 13.7349L6.10823 25.7202C6.0463 25.9023 6.02085 26.0949 6.03334 26.2869C6.04583 26.4789 6.09601 26.6666 6.18103 26.8392C6.26604 27.0118 6.38422 27.166 6.52882 27.2929C6.67342 27.4198 6.8416 27.517 7.02377 27.579C7.20594 27.6409 7.39853 27.6664 7.59053 27.6539C7.78253 27.6414 7.97019 27.5912 8.1428 27.5062C8.3154 27.4212 8.46957 27.303 8.59651 27.1584C8.72344 27.0138 8.82066 26.8456 8.8826 26.6634L12.9332 14.4562C12.97 14.3459 13.0491 14.2546 13.1531 14.2026C13.2572 14.1506 13.3777 14.142 13.488 14.1788C13.5984 14.2156 13.6897 14.2947 13.7417 14.3988C13.7937 14.5028 13.8023 14.6233 13.7655 14.7337L10.5472 25.5814C10.4944 25.7654 10.4783 25.958 10.4999 26.1482C10.5215 26.3384 10.5804 26.5225 10.6731 26.69C10.7659 26.8574 10.8907 27.005 11.0405 27.1242C11.1902 27.2434 11.362 27.3319 11.546 27.3848C11.73 27.4376 11.9226 27.4537 12.1128 27.4321C12.303 27.4105 12.4871 27.3516 12.6545 27.2589C12.822 27.1661 12.9695 27.0413 13.0887 26.8915C13.2079 26.7418 13.2965 26.57 13.3493 26.386L16.5676 15.455C16.6081 15.3189 16.7009 15.2044 16.8258 15.1368C16.9507 15.0691 17.0973 15.0539 17.2334 15.0943C17.3696 15.1348 17.484 15.2277 17.5517 15.3526C17.6193 15.4774 17.6346 15.6241 17.5941 15.7602L16.1792 22.0025Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان پا راست39-->
    <svg class="vector32" width="20" height="21" viewBox="0 0 20 21" @click="partClick(39)" :fill="fill39"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.3054 4.32883C17.6384 4.82822 18.4429 5.88247 18.8591 6.43734C19.414 7.13093 19.6914 9.21171 19.6914 9.62786C18.9978 11.2925 17.3332 10.1827 17.3332 8.93427C17.3332 7.68581 17.3332 7.54709 16.2235 7.40837C15.1137 7.26965 16.2789 9.62786 16.2235 9.62786C16.7506 10.0718 17.3055 12.0138 17.5551 13.0681C17.5829 13.1773 17.5829 13.2918 17.5551 13.401C17.139 15.565 15.9183 14.8992 15.086 14.3443C14.5311 13.9559 14.864 12.4855 14.7253 11.2925C14.713 11.1438 14.6519 11.0034 14.5516 10.893C14.4512 10.7826 14.3172 10.7085 14.1704 10.6821C13.9138 10.6387 13.6502 10.6949 13.4336 10.8393C13.217 10.9837 13.0638 11.2053 13.0052 11.459C12.8665 12.0138 13.4213 13.1236 14.2536 14.3721C15.086 15.6205 15.5021 17.2851 14.2536 18.1174C12.3671 19.2272 11.8954 16.9245 11.8954 15.6205C11.9787 14.7882 11.9787 12.9849 11.2018 12.43C10.2308 11.7364 9.67594 13.1236 10.0921 13.8172C10.6043 14.7279 10.9783 15.7096 11.2018 16.7303C11.3406 17.5626 11.618 19.9208 9.67594 20.3369C7.73388 20.7531 7.31773 18.2562 7.59517 17.4239C7.8726 16.5915 8.15004 14.2333 7.8726 13.1236C7.37322 12.0693 6.76286 12.2358 6.31896 12.6519C6.19602 12.7717 6.10982 12.9241 6.0705 13.0912C6.03118 13.2583 6.04039 13.4332 6.09702 13.5952C6.29122 14.1223 6.40219 14.6772 6.62414 17.3129C6.84609 19.9485 4.40465 20.4479 3.15618 20.3647C-1.00537 18.5613 1.49156 14.5385 2.32387 13.1513C2.83288 12.2619 3.11848 11.2623 3.15618 10.2382C3.18393 10.1828 3.12844 10.155 3.15618 10.0995V9.96081C3.15618 9.96081 3.0452 8.15747 2.4071 7.1587C2.38928 7.12938 2.38081 7.09532 2.38278 7.06107C2.38476 7.02682 2.39709 6.994 2.41816 6.96692C2.43922 6.93984 2.46801 6.91979 2.50072 6.90944C2.53344 6.8991 2.56851 6.89895 2.60131 6.909C4.32141 7.49162 8.62168 8.40717 12.811 4.66177C14.8085 2.88618 15.7241 1.74868 16.168 1.08284C16.2013 1.04637 16.2437 1.01946 16.2909 1.00487C16.3381 0.99029 16.3883 0.988551 16.4364 0.999862C16.4844 1.01117 16.5286 1.03513 16.5643 1.06922C16.6001 1.10331 16.6261 1.14633 16.6396 1.19382C16.7506 2.08161 16.6673 3.44105 17.028 3.99592"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--انگشتان پا چپ38-->
    <svg class="vector33" width="20" height="21" viewBox="0 0 20 21" @click="partClick(38)" :fill="fill38"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.77657 4.32883C2.44365 4.82822 1.63909 5.88247 1.22293 6.43734C0.668062 7.13093 0.390625 9.21171 0.390625 9.62786C1.08422 11.2925 2.74884 10.1827 2.74884 8.93427C2.74884 7.68581 2.74884 7.54709 3.85858 7.40837C4.96833 7.26965 3.80309 9.62786 3.85858 9.62786C3.33145 10.0718 2.77657 12.0138 2.52688 13.0681C2.49917 13.1773 2.49917 13.2918 2.52688 13.401C2.94304 15.565 4.16376 14.8992 4.99607 14.3443C5.55094 13.9559 5.21802 12.4855 5.35674 11.2925C5.36906 11.1438 5.43013 11.0034 5.53047 10.893C5.63081 10.7826 5.7648 10.7085 5.91161 10.6821C6.16826 10.6387 6.43182 10.6949 6.64841 10.8393C6.86499 10.9837 7.01825 11.2053 7.07684 11.459C7.21556 12.0138 6.66068 13.1236 5.82837 14.3721C4.99607 15.6205 4.57991 17.2851 5.82837 18.1174C7.71494 19.2272 8.18659 16.9245 8.18659 15.6205C8.10335 14.7882 8.10335 12.9849 8.88018 12.43C9.8512 11.7364 10.4061 13.1236 9.98992 13.8172C9.4777 14.7279 9.1037 15.7096 8.88018 16.7303C8.74146 17.5626 8.46402 19.9208 10.4061 20.3369C12.3481 20.7531 12.7643 18.2562 12.4869 17.4239C12.2094 16.5915 11.932 14.2333 12.2094 13.1236C12.7088 12.0693 13.3192 12.2358 13.7631 12.6519C13.886 12.7717 13.9722 12.9241 14.0115 13.0912C14.0508 13.2583 14.0416 13.4332 13.985 13.5952C13.7908 14.1223 13.6798 14.6772 13.4579 17.3129C13.2359 19.9485 15.6774 20.4479 16.9258 20.3647C21.0874 18.5613 18.5905 14.5385 17.7581 13.1513C17.2491 12.2619 16.9635 11.2623 16.9258 10.2382C16.8981 10.1828 16.9536 10.155 16.9258 10.0995V9.96081C16.9258 9.96081 17.0368 8.15747 17.6749 7.1587C17.6927 7.12938 17.7012 7.09532 17.6992 7.06107C17.6973 7.02682 17.6849 6.994 17.6639 6.96692C17.6428 6.93984 17.614 6.91979 17.5813 6.90944C17.5486 6.8991 17.5135 6.89895 17.4807 6.909C15.7606 7.49162 11.4603 8.40717 7.27105 4.66177C5.27351 2.88618 4.35796 1.74868 3.91406 1.08284C3.88076 1.04637 3.83833 1.01946 3.79114 1.00487C3.74396 0.99029 3.69374 0.988551 3.64567 0.999862C3.5976 1.01117 3.55342 1.03513 3.51769 1.06922C3.48196 1.10331 3.45598 1.14633 3.44243 1.19382C3.33145 2.08161 3.41468 3.44105 3.05401 3.99592"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--جناق سینه غیر قابل انتخاب-->
    <svg class="group-33350" width="9" height="44" viewBox="0 0 9 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.98466 2.04471L3.89844 42.7782" stroke="#5A5A5A" stroke-width="0.543113"
        stroke-dasharray="1.09 1.09" />
      <path
        d="M0.304688 0.344925C0.304688 0.344925 6.40829 2.56442 8.79424 0.344925C8.79424 0.344925 9.04393 11.2759 8.23937 21.7908C7.49029 31.7507 8.18388 32.805 4.54946 42.654C4.50462 42.7858 4.41894 42.8999 4.30486 42.9796C4.19078 43.0594 4.05423 43.1008 3.91505 43.0977C3.77588 43.0946 3.64131 43.0472 3.53089 42.9624C3.42046 42.8777 3.33994 42.7599 3.301 42.6263C2.49643 39.9074 1.137 34.1922 0.859561 26.0356C0.443406 14.3 0.304688 0.344925 0.304688 0.344925Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--سر 1-->
    <svg class="head" width="33" height="42" viewBox="0 0 33 42" @click="partClick(1)" :fill="fill1"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.8706 20.8802C31.8706 26.498 30.1323 31.5688 27.3409 35.2265C24.5498 38.8839 20.723 41.1111 16.5276 41.1111C12.3322 41.1111 8.50543 38.8839 5.7143 35.2265C2.92291 31.5688 1.18468 26.498 1.18468 20.8802C1.18468 15.2623 2.92291 10.1915 5.7143 6.53381C8.50543 2.87648 12.3322 0.649217 16.5276 0.649217C20.723 0.649217 24.5498 2.87648 27.3409 6.53381C30.1323 10.1915 31.8706 15.2623 31.8706 20.8802Z"
        stroke="#212121" stroke-width="0.814669" />
      <path d="M4.58008 11.1042C8.73607 7.00571 19.3339 1.26787 28.477 11.1042" stroke="#212121" stroke-width="0.695184"
        stroke-linecap="round" />
    </svg>
    <!--کف دست راست 16-->
    <svg class="vector35" width="20" height="20" viewBox="0 0 20 20" @click="partClick(16)" :fill="fill16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.45495 6.8456C3.86629 9.34559 5.18238 14.9893 5.75542 15.9951C9.4924 18.1307 14.8035 16.5929 18.5942 9.83462C18.7115 9.62543 18.6806 9.35924 18.5332 9.17003C17.5943 7.96476 14.8866 4.0997 12.5997 3.51283L12.413 3.43125C11.0362 2.90358 7.74867 4.22045 5.61242 5.49341C5.08006 5.81064 4.59698 6.24239 4.45495 6.8456Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--کف دست چپ15-->
    <svg class="vector36" width="20" height="20" viewBox="0 0 20 20" @click="partClick(15)" :fill="fill15"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3878 6.8456C15.9765 9.34559 14.6604 14.9893 14.0874 15.9951C10.3504 18.1307 5.03923 16.5929 1.24859 9.83462C1.13126 9.62543 1.1622 9.35924 1.3096 9.17003C2.24852 7.96476 4.95613 4.0997 7.24304 3.51283L7.42977 3.43125C8.80656 2.90358 12.0941 4.22045 14.2304 5.49341C14.7627 5.81064 15.2458 6.24239 15.3878 6.8456Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساق چپ32-->
    <svg class="group-33348" width="22" height="66" viewBox="0 0 22 66" @click="partClick(32)" :fill="fill32"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M11.2354 8.41964L15.0371 65.4465" stroke="#5A5A5A" stroke-width="0.543113" />
      <path
        d="M1.4997 0.849445C3.35853 2.3476 8.24141 6.37046 10.4054 8.22928C10.615 8.40122 10.8803 8.49049 11.1511 8.48027C11.422 8.47005 11.6798 8.36102 11.8758 8.17378C13.3185 6.70336 16.62 3.40186 18.6175 2.09791C18.6991 2.0473 18.7929 2.01994 18.8889 2.01873C18.9848 2.01752 19.0793 2.0425 19.1621 2.09103C19.2449 2.13957 19.3129 2.20981 19.3587 2.29413C19.4045 2.37846 19.4264 2.4737 19.4221 2.56957C19.3111 4.23419 19.2002 7.6744 20.0325 9.08933C20.0617 9.11992 20.081 9.15859 20.088 9.20031C20.837 11.9469 22.1687 21.1023 20.0602 51.0932V51.121C20.0047 51.4539 19.1724 57.6685 19.5053 61.2751C19.8105 64.9928 19.2279 65.187 17.1194 65.2702C15.0109 65.3535 10.6274 67.7949 9.51762 62.6623C8.40787 57.5297 5.02314 42.6314 4.24632 39.4964C3.49724 36.4168 -1.08045 13.9445 0.61191 1.15465C0.633407 1.0634 0.677668 0.97907 0.74057 0.909559C0.803473 0.840048 0.882963 0.7876 0.971618 0.757124C1.06027 0.726649 1.1552 0.719136 1.24755 0.73528C1.33989 0.751424 1.42664 0.790699 1.4997 0.849445Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--ساق راست33-->
    <svg class="group-33349" width="22" height="66" viewBox="0 0 22 66" @click="partClick(33)" :fill="fill33"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5234 8.23148L5.28885 65.1447" stroke="#5A5A5A" stroke-width="0.543113" />
      <path
        d="M20.4165 0.937913C18.4467 2.46381 13.5361 6.23696 11.3721 7.98481C11.1665 8.15014 10.9056 8.23072 10.6426 8.21009C10.3796 8.18946 10.1344 8.06918 9.95715 7.87383C8.59771 6.40341 5.49043 3.1019 3.49288 1.68698C3.40327 1.62026 3.29657 1.58031 3.18517 1.57176C3.07377 1.56322 2.96225 1.58644 2.8635 1.63872C2.76476 1.69099 2.68286 1.77018 2.6273 1.86712C2.57174 1.96405 2.54479 2.07476 2.54959 2.18638C2.60508 3.93423 2.60508 7.2912 1.71728 8.59516C0.912718 11.2308 -0.724155 20.2752 0.52431 50.5436C0.52431 50.5436 1.2179 57.0356 0.801747 60.7255C0.385592 64.4154 0.968212 64.6373 3.07673 64.8038C5.18525 64.9703 9.48551 67.5227 10.734 62.3901C11.9824 57.2575 15.7833 42.4979 16.6434 39.3906C17.5034 36.3666 22.6638 14.1716 21.3875 1.32633C21.3699 1.22287 21.326 1.12565 21.2601 1.04402C21.1941 0.962384 21.1083 0.899065 21.0108 0.860087C20.9134 0.82111 20.8076 0.807785 20.7035 0.821411C20.5995 0.835038 20.5006 0.87516 20.4165 0.937913Z"
        stroke="#212121" stroke-width="0.814669" />
    </svg>
    <!--گوش چپ 40-->
    <svg class="group-33355" width="16" height="22" viewBox="0 0 16 22" @click="partClick(40)" :fill="fill40"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.664 2.8061C14.3128 3.67251 15.8279 5.82416 15.6226 8.73958C15.5143 9.8474 15.1487 10.9146 14.555 11.8562C13.7331 13.3496 13.2206 14.9933 13.0481 16.6892C13.0152 17.0013 13.007 17.1861 13.007 17.1861C13.007 17.3092 12.9659 17.4324 12.9659 17.5556C12.9659 17.6788 12.9248 17.6788 12.9248 17.7609C12.9248 17.8431 12.8838 17.8841 12.8838 17.9662C12.8151 18.1962 12.7342 18.4224 12.6415 18.6438C12.586 18.7946 12.5201 18.9414 12.4444 19.0831C12.2926 19.3509 12.1239 19.6087 11.9394 19.8551C11.81 20.0255 11.6581 20.1775 11.4877 20.3068C11.328 20.4659 11.1486 20.6039 10.9539 20.7174C10.5284 20.9859 10.0538 21.1673 9.55777 21.2512H9.11016C8.8995 21.254 8.68911 21.2361 8.48195 21.1978C8.31438 21.169 8.1514 21.1179 7.99739 21.0459C7.72384 20.92 7.46263 20.7687 7.2172 20.5942C6.98153 20.4089 6.76428 20.2012 6.56843 19.9742C6.51095 19.9167 6.45756 19.8551 6.40418 19.7935L5.46389 18.4754C5.15181 17.9621 4.87256 17.4489 4.55638 16.9356C4.46526 16.8043 4.38296 16.6671 4.31002 16.525L4.26896 16.4428C4.26462 16.4117 4.25021 16.3829 4.22791 16.3607C4.18685 16.2786 4.14577 16.2375 4.10471 16.1554C3.94089 15.886 3.76268 15.6255 3.57088 15.3752C3.20132 14.8414 2.79073 14.3487 2.42117 13.7738C2.02922 13.223 1.69875 12.6309 1.43566 12.0081C1.22639 11.5577 1.068 11.0853 0.963439 10.5997C0.888877 10.2448 0.869481 9.88055 0.905946 9.51976C0.994406 8.32568 1.17148 7.13983 1.43566 5.97199C1.62108 5.32019 1.86861 4.68767 2.1748 4.08313C2.25693 3.91888 2.33904 3.79569 2.42117 3.63145L2.46222 3.59038L2.50327 3.54932L2.58543 3.42613C2.62649 3.34401 2.66752 3.30295 2.70858 3.22082C2.74964 3.1387 2.79073 3.09764 2.83179 3.01551L2.99605 2.85126C3.03778 2.77336 3.09341 2.70377 3.16026 2.64595C3.20132 2.56383 3.28345 2.52277 3.32451 2.44064C3.52982 2.19427 3.77619 1.98896 3.9815 1.74259L4.14576 1.57834L4.31002 1.41409C4.4332 1.33196 4.5564 1.20878 4.67959 1.12665C4.80277 1.04453 4.80277 1.04453 4.8849 1.00347C4.96702 0.962405 5.00808 0.921343 5.09021 0.880281C5.21837 0.795647 5.35623 0.726717 5.50083 0.67497L5.54188 0.633908C5.55277 0.633908 5.5632 0.629582 5.5709 0.621881C5.5786 0.61418 5.58293 0.603736 5.58293 0.592845L5.70614 0.551784C5.78826 0.510722 5.82933 0.469659 5.91145 0.469659C5.99357 0.469659 6.03464 0.428597 6.11676 0.387535C6.19889 0.346472 6.23995 0.346473 6.32207 0.305411C6.4042 0.264349 6.60951 0.223286 6.73269 0.182224C6.85588 0.141162 6.85588 0.141162 6.938 0.141162C7.02013 0.141162 7.06119 0.1001 7.14332 0.1001C7.22544 0.1001 7.2665 0.0590377 7.34863 0.0590377C7.41959 0.0654286 7.49089 0.0511687 7.55394 0.0179754H8.51067C8.69351 0.0172005 8.87616 0.0309311 9.05683 0.0590377L9.56599 0.141162C9.81729 0.190433 10.0644 0.259075 10.3051 0.346473C10.3668 0.356755 10.4241 0.385369 10.4693 0.428597C10.5104 0.469659 10.5925 0.469659 10.6336 0.510722C10.6747 0.551784 10.7568 0.551783 10.7978 0.592845C10.8389 0.633908 10.921 0.633908 10.9621 0.67497C11.0032 0.716032 11.0032 0.716032 11.0442 0.716032C11.0853 0.716032 11.0853 0.757095 11.1263 0.757095C11.1674 0.757095 11.2085 0.798156 11.2906 0.839218C11.3727 0.880281 11.3727 0.880281 11.4548 0.921343C11.537 0.962405 11.537 0.962405 11.6191 1.00347C11.7012 1.04453 11.8244 1.12665 11.9065 1.16772C11.9886 1.20878 11.9886 1.20878 12.0297 1.24984C12.0708 1.2909 12.1118 1.2909 12.1529 1.33196C12.727 1.74998 13.2386 2.24773 13.6722 2.8102C13.7543 2.93339 13.8364 3.01551 13.9186 3.1387C13.9596 3.17976 14.0007 3.26189 14.0418 3.30295C14.0668 3.32249 14.0872 3.34738 14.1014 3.37579C14.1156 3.40421 14.1233 3.43543 14.1239 3.4672C14.1925 3.53918 14.2481 3.62255 14.2881 3.71357C14.3198 3.78719 14.3613 3.85624 14.4113 3.91888C14.4524 4.001 14.4934 4.04207 14.4934 4.08313"
        stroke="#212121" stroke-width="1.08623" stroke-miterlimit="10" />
    </svg>
    <!--بینی 44-->
    <svg class="group-33352" width="17" height="24" viewBox="0 0 17 24" @click="partClick(44)" :fill="fill44"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2965 21.6628C15.0515 21.8413 14.7629 21.9504 14.4611 21.9786C14.1593 22.0067 13.8555 21.9529 13.5817 21.8227C13.0175 21.5784 12.2489 21.6272 10.7651 22.5335C7.95745 25.0124 6.32261 23.1777 4.85658 22.2225C4.17173 21.766 3.35385 21.5518 2.53315 21.6139C2.16894 21.6488 1.80311 21.5663 1.48914 21.3785C-0.0035478 20.4455 0.600655 19.5081 2.34212 16.154C4.22131 12.5423 5.22088 6.09617 5.45189 3.71498C5.52256 2.88061 5.90478 2.10344 6.52252 1.53815C6.8468 1.2264 7.25625 1.0178 7.69907 0.938728C8.14189 0.859653 8.59822 0.913646 9.01035 1.09389C9.52135 1.30857 9.9682 1.65166 10.3076 2.08988C10.6469 2.5281 10.8673 3.04658 10.9473 3.59504C11.4404 6.61595 12.8576 14.417 14.5546 16.4784C17.0424 19.4149 16.2205 20.9431 15.2965 21.6628Z"
        stroke="#212121" stroke-width="1.08623" stroke-miterlimit="10" />
    </svg>
    <!--چشم راست 43-->
    <svg class="group-33357" width="21" height="12" viewBox="0 0 21 12" @click="partClick(43)" :fill="fill43"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.452148 6.06342C0.452148 6.06342 8.97476 17.8586 20.376 6.34425C20.376 6.34425 11.7636 -7.13591 0.452148 6.06342Z"
        stroke="#212121" stroke-width="1.08623" stroke-miterlimit="10" />
    </svg>
    <!--گوش راست 41-->
    <svg class="group-33353" width="16" height="22" viewBox="0 0 16 22" @click="partClick(41)" :fill="fill41"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.89461 2.80604C2.24582 3.67245 0.730647 5.8241 0.935958 8.73952C1.04434 9.84734 1.40991 10.9145 2.00356 11.8561C2.82544 13.3496 3.33796 14.9933 3.51054 16.6891C3.54339 17.0012 3.55162 17.186 3.55162 17.186C3.55162 17.3092 3.59267 17.4324 3.59267 17.5556C3.59267 17.6787 3.63374 17.6787 3.63374 17.7609C3.63374 17.843 3.6748 17.8841 3.6748 17.9662C3.74352 18.1961 3.8244 18.4223 3.91707 18.6437C3.97262 18.7945 4.03846 18.9413 4.11416 19.0831C4.26603 19.3508 4.43472 19.6087 4.61922 19.855C4.74855 20.0254 4.90053 20.1774 5.07092 20.3067C5.23057 20.4659 5.40996 20.6039 5.60472 20.7173C6.03024 20.9858 6.50475 21.1672 7.00082 21.2512H7.44844C7.65909 21.254 7.86948 21.2361 8.07665 21.1978C8.24421 21.169 8.40719 21.1179 8.5612 21.0458C8.83476 20.9199 9.09596 20.7687 9.34139 20.5942C9.57706 20.4088 9.79431 20.2012 9.99016 19.9741C10.0476 19.9166 10.101 19.855 10.1544 19.7934L11.0947 18.4754C11.4068 17.9621 11.686 17.4488 12.0022 16.9355C12.0933 16.8043 12.1756 16.6671 12.2486 16.5249L12.2896 16.4428C12.294 16.4116 12.3084 16.3828 12.3307 16.3607C12.3717 16.2785 12.4128 16.2375 12.4539 16.1553C12.6177 15.8859 12.7959 15.6255 12.9877 15.3752C13.3573 14.8414 13.7679 14.3486 14.1374 13.7737C14.5294 13.2229 14.8598 12.6308 15.1229 12.0081C15.3322 11.5576 15.4906 11.0852 15.5952 10.5996C15.6697 10.2447 15.6891 9.88049 15.6526 9.5197C15.5642 8.32562 15.3871 7.13977 15.1229 5.97193C14.9375 5.32013 14.69 4.68761 14.3838 4.08307C14.3017 3.91882 14.2196 3.79563 14.1374 3.63138L14.0964 3.59032L14.0553 3.54926L13.9732 3.42607C13.9321 3.34395 13.8911 3.30289 13.85 3.22076C13.8089 3.13864 13.7679 3.09758 13.7268 3.01545L13.5625 2.8512C13.5208 2.7733 13.4652 2.70371 13.3983 2.64589C13.3573 2.56377 13.2751 2.52271 13.2341 2.44058C13.0288 2.19421 12.7824 1.9889 12.5771 1.74253L12.4128 1.57828L12.2486 1.41403C12.1254 1.3319 12.0022 1.20872 11.879 1.12659C11.7558 1.04447 11.7558 1.04447 11.6737 1.00341C11.5916 0.962344 11.5505 0.921282 11.4684 0.88022C11.3402 0.795586 11.2024 0.726656 11.0578 0.674909L11.0167 0.633847C11.0058 0.633847 10.9954 0.629521 10.9877 0.62182C10.98 0.614119 10.9757 0.603675 10.9757 0.592784L10.8525 0.551723C10.7703 0.510661 10.7293 0.469598 10.6471 0.469598C10.565 0.469598 10.524 0.428536 10.4418 0.387474C10.3597 0.346411 10.3186 0.346412 10.2365 0.30535C10.1544 0.264288 9.94909 0.223225 9.8259 0.182163C9.70271 0.141101 9.70271 0.141101 9.62059 0.141101C9.53847 0.141101 9.4974 0.100039 9.41528 0.100039C9.33315 0.100039 9.29209 0.0589767 9.20997 0.0589767C9.139 0.0653676 9.0677 0.0511076 9.00466 0.0179143H8.04793C7.86509 0.0171395 7.68244 0.0308701 7.50177 0.0589767L6.9926 0.141101C6.7413 0.190372 6.49422 0.259014 6.25351 0.346412C6.19177 0.356694 6.13453 0.385308 6.08925 0.428536C6.04819 0.469598 5.96606 0.469598 5.925 0.510661C5.88393 0.551723 5.80182 0.551722 5.76076 0.592784C5.7197 0.633847 5.63757 0.633847 5.5965 0.674909C5.55544 0.715971 5.55544 0.715971 5.51437 0.715971C5.47331 0.715971 5.47333 0.757034 5.43227 0.757034C5.39121 0.757034 5.35014 0.798095 5.26801 0.839157C5.18589 0.88022 5.18588 0.88022 5.10375 0.921282C5.02163 0.962344 5.02164 0.962344 4.93952 1.00341C4.85739 1.04447 4.7342 1.12659 4.65208 1.16766C4.56995 1.20872 4.56996 1.20872 4.5289 1.24978C4.48783 1.29084 4.44678 1.29084 4.40572 1.3319C3.83158 1.74991 3.31999 2.24767 2.88641 2.81014C2.80429 2.93333 2.72215 3.01545 2.64002 3.13864C2.59896 3.1797 2.5579 3.26182 2.51684 3.30289C2.4918 3.32243 2.47142 3.34732 2.45722 3.37573C2.44301 3.40415 2.43532 3.43537 2.43471 3.46714C2.3661 3.53912 2.31054 3.62249 2.27048 3.71351C2.23875 3.78713 2.19733 3.85618 2.1473 3.91882C2.10623 4.00094 2.06517 4.04201 2.06517 4.08307"
        stroke="#212121" stroke-width="0.821243" stroke-miterlimit="10" />
    </svg>
    <!--چشم چپ 42-->
    <svg class="group-33356" width="21" height="12" viewBox="0 0 21 12" @click="partClick(42)" :fill="fill42"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.793945 5.97736C0.793945 5.97736 9.31656 17.7725 20.7178 6.25819C20.7178 6.25819 12.1054 -7.22197 0.793945 5.97736Z"
        stroke="#212121" stroke-width="1.08623" stroke-miterlimit="10" />
    </svg>
  </div>
</template>
<script>
import HumanFrontHelper from '@/Helpers/FollowUp/HumanFrontHelper';
export default {
  mixins: [HumanFrontHelper],
  created() {
    this.$root.$refs.humanFront = this;
  },
  props: {
    hasClick: {
      type: Boolean,
      require: true,
      default: false,
    },
    data: {
      type: Array,
      require: false,
      default: () => [],
    },
  },
  watch: {
    data: {
      handler: function (currentVal) {
        this.clearAllParts();
        currentVal.forEach(({ bodyPartId, color }) => {
          this.setColorToEachPart(bodyPartId, color);
        });
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.txtStyle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 5px 10px;
  color: white;
  background-color: var(--dark-color);
  border-radius: 4px;
  position: absolute;
  left: 121.78px;
  top: 0;
  overflow: visible;
}

.vector {
  position: absolute;
  left: 133.03px;
  top: 455.87px;
  overflow: visible;
}

.vector2 {
  position: absolute;
  left: 150.72px;
  top: 455.87px;
  overflow: visible;
}

.vector3 {
  position: absolute;
  left: 117.39px;
  top: 289.49px;
  overflow: visible;
}

.vector4 {
  position: absolute;
  left: 150.11px;
  top: 289.49px;
  overflow: visible;
}

.vector5 {
  position: absolute;
  left: 152.66px;
  top: 356.26px;
  overflow: visible;
}

.vector6 {
  position: absolute;
  left: 124.71px;
  top: 356.26px;
  overflow: visible;
}

.vector7 {
  position: absolute;
  left: 149.75px;
  top: 465.61px;
  overflow: visible;
}

.vector8 {
  position: absolute;
  left: 126.89px;
  top: 465.61px;
  overflow: visible;
}

.vector9 {
  position: absolute;
  left: 151.85px;
  top: 253.43px;
  overflow: visible;
}

.vector10 {
  position: absolute;
  left: 117.84px;
  top: 253.43px;
  overflow: visible;
}

.vector11 {
  position: absolute;
  left: 141.95px;
  top: 273.05px;
  overflow: visible;
}

._32 {
  position: absolute;
  left: 155.36px;
  top: 147.74px;
  overflow: visible;
}

.vector12 {
  position: absolute;
  left: 119.36px;
  top: 147.74px;
  overflow: visible;
}

.vector13 {
  position: absolute;
  left: 122.94px;
  top: 189.41px;
  overflow: visible;
}

.vector14 {
  position: absolute;
  left: 150.99px;
  top: 189.41px;
  overflow: visible;
}

.vector15 {
  position: absolute;
  left: 124.14px;
  top: 237.59px;
  overflow: visible;
}

.vector16 {
  position: absolute;
  left: 150.86px;
  top: 237.59px;
  overflow: visible;
}

.vector17 {
  position: absolute;
  left: 140.76px;
  top: 120.65px;
  overflow: visible;
}

.vector18 {
  position: absolute;
  left: 158.29px;
  top: 129.22px;
  overflow: visible;
}

.vector19 {
  position: absolute;
  left: 125.25px;
  top: 129.22px;
  overflow: visible;
}

.vector20 {
  position: absolute;
  left: 176.44px;
  top: 139.24px;
  overflow: visible;
}

.vector21 {
  position: absolute;
  left: 102.17px;
  top: 138.13px;
  overflow: visible;
}

.vector22 {
  position: absolute;
  left: 182.84px;
  top: 181.44px;
  overflow: visible;
}

.vector23 {
  position: absolute;
  left: 100.21px;
  top: 181.44px;
  overflow: visible;
}

.vector24 {
  position: absolute;
  left: 188.52px;
  top: 208.06px;
  overflow: visible;
}

.vector25 {
  position: absolute;
  left: 94.31px;
  top: 208.06px;
  overflow: visible;
}

.vector26 {
  position: absolute;
  left: 190.83px;
  top: 224.97px;
  overflow: visible;
}

.vector27 {
  position: absolute;
  left: 88.66px;
  top: 224.97px;
  overflow: visible;
}

.vector28 {
  position: absolute;
  left: 196.88px;
  top: 254.46px;
  overflow: visible;
}

.vector29 {
  position: absolute;
  left: 87.74px;
  top: 254.46px;
  overflow: visible;
}

.vector30 {
  border-radius: 0px;
  position: absolute;
  left: 205.3px;
  top: 278.65px;
  overflow: visible;
}

.vector31 {
  border-radius: 0px;
  position: absolute;
  left: 94.54px;
  top: 278.65px;
  transform: translate(-21.09px, -0.08px);
  overflow: visible;
}

.vector32 {
  position: absolute;
  left: 152.82px;
  top: 491.99px;
  overflow: visible;
}

.vector33 {
  position: absolute;
  left: 122.39px;
  top: 491.99px;
  overflow: visible;
}

.group-33350 {
  position: absolute;
  left: 146.3px;
  top: 143.34px;
  overflow: visible;
}

.head {
  position: absolute;
  left: 135.78px;
  top: 78.24px;
  overflow: visible;
}

.vector35 {
  border-radius: 0px;
  position: absolute;
  left: 196.27px;
  top: 276.19px;
  transform: translate(3.63px, -8.29px);
  overflow: visible;
}

.vector36 {
  border-radius: 0px;
  position: absolute;
  left: 100.57px;
  top: 276.19px;
  transform: translate(-18.8px, -8.29px);
  overflow: visible;
}

.group-33348 {
  position: absolute;
  left: 124.24px;
  top: 387.73px;
  overflow: visible;
}

.group-33349 {
  position: absolute;
  left: 152.07px;
  top: 387.82px;
  overflow: visible;
}

.group-33355 {
  position: absolute;
  left: 62.64px;
  top: 88.02px;
  transform: translate(-15.3px, -0.54px);
  overflow: visible;
}

.group-33352 {
  position: absolute;
  left: 235.64px;
  top: 153.9px;
  overflow: visible;
}

.group-33357 {
  position: absolute;
  left: 232.45px;
  top: 128.27px;
  overflow: visible;
}

.group-33353 {
  position: absolute;
  left: 234.92px;
  top: 88.02px;
  overflow: visible;
}

.group-33356 {
  position: absolute;
  left: 47.79px;
  top: 127.18px;
  overflow: visible;
}
</style>
